import {
  CheckCircleFilled,
  ExclamationCircleFilled,
  FireFilled,
  InfoCircleFilled,
  WarningOutlined,
} from '@ant-design/icons';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { TICKET_PRIORITY, TicketPriorityString } from '@/model/Ticket/TicketConstants';

const priorityIcons = {
  [TICKET_PRIORITY.CRITICO]: {
    icon: <FireFilled style={{ color: '#cf1322' }} />,
    color: '#cf1322',
  },
  [TICKET_PRIORITY.ALTA]: {
    icon: <WarningOutlined style={{ color: '#f5222d' }} />,
    color: '#f5222d',
  },
  [TICKET_PRIORITY.NORMAL]: {
    icon: <ExclamationCircleFilled style={{ color: '#faad14' }} />,
    color: '#faad14',
  },
  [TICKET_PRIORITY.BAJA]: {
    icon: <InfoCircleFilled style={{ color: '#a0d911' }} />,
    color: '#a0d911',
  },
  [TICKET_PRIORITY.MUY_BAJA]: {
    icon: <CheckCircleFilled style={{ color: '#52c41a' }} />,
    color: '#52c41a',
  },
};

interface PriorityLabelProps {
  value: number;
}

const PriorityLabel = (props: PriorityLabelProps) => {
  const { t } = useTranslation();
  const { value } = props;
  const iconData = useMemo(() => priorityIcons[value], [value]);

  return (
    <span className="PrioritySelectLabel">
      {iconData ? (
        <>
          {iconData.icon}
          <span style={{ color: iconData.color }}>
            {'  '}
            {t(TicketPriorityString[value])}
          </span>
        </>
      ) : (
        <span> {t('No definida')}</span>
      )}
    </span>
  );
};

export default PriorityLabel;
